exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.not-found[data-v-d29df9ce] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.not-found .error-message[data-v-d29df9ce] {\n    margin: 2vw;\n    font-size: 10vw;\n    line-height: 10vw;\n}\n.not-found .error[data-v-d29df9ce] {\n    margin: 2vw;\n    font-size: 3vw;\n    line-height: 4vw;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d29df9ce","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/errors/NotFoundError.vue
// module id = hRgw
// module chunks = 1